import { definePreset } from '@primeng/themes';
import Aura from '@primeng/themes/aura';

const SierraTheme = definePreset(Aura, {
  components: {
    inputtext: {
      colorScheme: {
        light: {
          border: {
            radius: '8px',
          },
        },
      },
    },
    autocomplete: {
      colorScheme: {
        light: {
          dropdown: {
            border: {
              radius: '8px',
            },
          },
        },
      },
    },
    button: {
      colorScheme: {
        light: {
          border: {
            radius: '8px',
          },
        },
      },
    },
    datatable: {
      colorScheme: {
        light: {
          header: {
            cell: {
              background: '{primary.400}',
              color: '#ffffff',
            },
          },
          column: {
            title: {
              font: {
                weight: '500',
              },
            },
          },
          row: {
            background: 'transparent',
            hover: {
              background: '#ffffff',
            },
          },
          footer: {
            cell: {
              background: '#a8dadc1a',
            },
          },
        },
      },
    },
  },
  semantic: {
    borderRadius: {
      none: '0',
      xs: '2px',
      sm: '4px',
      md: '8px',
      lg: '12px',
      xl: '16px',
    },
    primary: {
      50: '#e2ebe9',
      100: '#bfd1cd',
      200: '#9bb6b0',
      300: '#779c94',
      400: '#548277',
      500: '#2d514e', // ← Color principal
      600: '#284945',
      700: '#223f3c',
      800: '#1d3533',
      900: '#172a29',
      950: '#101f1f',
    },
    secondary: {
      50: '#e6eaea',
      100: '#BEC9C8',
      200: '#aab7b6',
      300: '#95a5a4',
      400: '#7f9392',
      500: '#6a8180',
      600: '#566e6d',
      700: '#294A47',
      800: '#203937',
      900: '#162726',
      950: '#0d1515',
    },
    surface: {
      50: '#fcfdfe',
      100: '#f6f8fa',
      200: '#f2f4f8',
      300: '#ecf0f5',
      400: '#e8edf3',
      500: '#e2e8f0',
      600: '#ced3da',
      700: '#a0a5aa',
      800: '#7c8084',
      900: '#5f6165',
      950: '#5f6165',
    },
    emerald: {
      50: '#eff6f5',
      100: '#cce2e1',
      200: '#b3d4d2',
      300: '#90c1bd',
      400: '#7bb5b1',
      500: '#5aa29d',
      600: '#52938f',
      700: '#40736f',
      800: '#325956',
      900: '#264442',
      950: '#264442',
    },
    green: {
      50: '#e7f8ee',
      100: '#b4e9ca',
      200: '#90deb1',
      300: '#5ecf8d',
      400: '#3ec677',
      500: '#0eb855',
      600: '#0da74d',
      700: '#0a833c',
      800: '#08652f',
      900: '#064d24',
      950: '#064d24',
    },
    red: {
      50: '#f8e8e8',
      100: '#e9b9b9',
      200: '#df9797',
      300: '#d06767',
      400: '#c74949',
      500: '#b91c1c',
      600: '#a81919',
      700: '#831414',
      800: '#660f0f',
      900: '#4e0c0c',
      950: '#4e0c0c',
    },
    orange: {
      50: '#fff1e6',
      100: '#ffd5b0',
      200: '#ffc08a',
      300: '#ffa454',
      400: '#ff9233',
      500: '#ff7700',
      600: '#e86c00',
      700: '#b55400',
      800: '#8c4100',
      900: '#6b3200',
      950: '#6b3200',
    },
    sky: {
      50: '#e6f0f6',
      100: '#b1d1e2',
      200: '#8bbad4',
      300: '#569bc0',
      400: '#3587b4',
      500: '#0369a1',
      600: '#036093',
      700: '#024b72',
      800: '#023a59',
      900: '#012c44',
      950: '#012c44',
    },
  },
});

export default SierraTheme;
